import { CustomError } from './custom_error';
function combineErrors(errors, myStack) {
    return `${myStack ? `${myStack}\n` : ''}${errors
        .map((err, index) => {
        const stackSplit = (err.stack === undefined ? '' : err.stack).split('\n');
        let causedByText = stackSplit.shift();
        if (causedByText !== undefined) {
            causedByText = causedByText.replace(/ \(/g, ' :('); // escape ' (' with ' :('
        }
        return `at Cause nr ${index + 1}: ${causedByText}:0:0\n${stackSplit.map((frame) => `-  ${frame}`).join('\n')}`;
    })
        .join('\n')}`;
}
export class AggregateError extends CustomError {
    constructor(errors, opts = {}) {
        super(`Aggregate of ${errors.length} errors: ${errors.map((err) => err.message).join('; ')}`, opts);
        this.errors = errors;
        Object.setPrototypeOf(this, AggregateError.prototype);
        this.stack = combineErrors(errors, this.stack);
    }
}
//# sourceMappingURL=aggregate_error.js.map